
import { Component, Prop, Vue } from 'vue-property-decorator';

@Component
export default class ProductCard extends Vue {
  @Prop(Object)
  product!: any;

  $helpers: any;

  get link(): string {
    if (this.product.content.url && this.product.content.url.length) {
      const url = this.product.content.url
        .replace('/', '')
        .split('/')
        .splice(1, this.product.content.url.split('/').length);

      return `/${url.join('/')}`;
    }

    return '';
  }

  get image(): string {
    if (
      this.product.content.excerptImages &&
      this.product.content.excerptImages.length &&
      this.product.content.excerptImages[0]
    ) {
      return this.product.content.excerptImages[0];
    }

    return '';
  }

  get category(): string {
    if (
      this.product.content.excerptCategories &&
      this.product.content.excerptCategories.length &&
      this.product.content.excerptCategories[0].name
    ) {
      return this.product.content.excerptCategories[0].name;
    }

    return '';
  }

  get title(): string {
    if (
      this.product.content.excerptTitle &&
      this.product.content.excerptTitle.length
    ) {
      return this.product.content.excerptTitle;
    }

    if (this.product.content.title && this.product.content.title.length) {
      return this.product.content.title;
    }

    return '';
  }
}
